import { render, staticRenderFns } from "./Entrance.vue?vue&type=template&id=15f0e1b2&scoped=true&"
import script from "./Entrance.vue?vue&type=script&lang=js&"
export * from "./Entrance.vue?vue&type=script&lang=js&"
import style0 from "./Entrance.vue?vue&type=style&index=0&id=15f0e1b2&prod&lang=css&"
import style1 from "./Entrance.vue?vue&type=style&index=1&id=15f0e1b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f0e1b2",
  null
  
)

export default component.exports